(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["b2b-clear-cart-button"] && !Shopify.designMode) return;
  try {
    if (!window.PineConeB2BClearCartInitialized) {
  window.PineConeB2BClearCartInitialized = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-b2b-clear-cart]');
    if (!button || button.disabled) return;

    const confirmText = button.dataset.confirmText || '';
    if (!window.confirm(confirmText)) return;

    const quickOrder = button.closest('b2b-quick-order');
    const errorTarget = button.dataset.errorTarget
      ? document.querySelector(button.dataset.errorTarget)
      : null;
    let cleared = false;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (errorTarget) errorTarget.textContent = '';

    try {
      if (typeof quickOrder?.prepareForCartClear === 'function') {
        await quickOrder.prepareForCartClear();
      }

      const rootUrl = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${rootUrl}cart/clear.js`, {
        method: 'POST',
        cache: 'no-store',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          sections: ['cart-icon-bubble'],
          sections_url: window.location.pathname,
        }),
      });

      const cartState = await response.json();
      if (!response.ok || cartState.status || cartState.errors) {
        throw new Error(cartState.description || cartState.message || button.dataset.errorText);
      }

      cleared = true;

      if (button.dataset.reloadOnSuccess === 'true') {
        window.location.assign(window.routes?.cart_url || `${rootUrl}cart`);
        return;
      }

      document.dispatchEvent(
        new CustomEvent('b2b:cart-cleared', {
          detail: { cart: cartState },
        })
      );

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'b2b-clear-cart',
          cartData: cartState,
        });
      }
    } catch (error) {
      const message = error.message || button.dataset.errorText;
      if (errorTarget) errorTarget.textContent = message;
      document.dispatchEvent(
        new CustomEvent('b2b:cart-clear-error', {
          detail: { message },
        })
      );
    } finally {
      button.removeAttribute('aria-busy');
      if (!cleared) button.disabled = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pc-legal-notice"] && !Shopify.designMode) return;
  try {
    (() => {
    let returnFocus;
    let observedDialog;
    const bindDialog = (dialog) => {
      if (observedDialog === dialog) return;
      observedDialog = dialog;
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('pc-legal-open');
        if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
      });
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
    };
    document.addEventListener('click', (event) => {
      const opener = event.target.closest?.('[data-pc-legal-open]');
      const closer = event.target.closest?.('[data-pc-legal-close]');
      if (!opener && !closer) return;
      const dialog = document.getElementById('PcLegalNotice');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      if (opener) {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        returnFocus = opener;
        bindDialog(dialog);
        dialog.showModal();
        document.documentElement.classList.add('pc-legal-open');
      } else if (closer) {
        dialog.close();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
